import { SectionTitle } from '@elotech/components';
import DebitosEmAbertoTable from 'itbi-common/components/declaracao-itbi/DebitosEmAbertoTable';
import React from 'react';

import {
  DebitosEmAbertoComTotalizadorDTO,
  ParcelamentoCadastroDTO
} from '../../../types';
import { Requerente } from './ParcelamentoFormPage';
import ParcelamentoIdentificacao from './ParcelamentoIdentificacao';

type Props = {
  cadastro: ParcelamentoCadastroDTO;
  requerente: Requerente;
  debitosEmAberto?: DebitosEmAbertoComTotalizadorDTO;
  loading: boolean;
};

const DebitosStep: React.FC<Props> = ({
  cadastro,
  requerente,
  debitosEmAberto,
  loading
}) => {
  return (
    <>
      <ParcelamentoIdentificacao cadastro={cadastro} requerente={requerente} />
      <SectionTitle>Débitos em aberto</SectionTitle>
      <DebitosEmAbertoTable
        debitosEmAberto={debitosEmAberto}
        loading={loading}
      />
    </>
  );
};

export default DebitosStep;
